import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ReportConstructionPOInfo } from '@app/cp/shared/models/ReportConstructionPOInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { SItem } from '@app/cp/shared/models/SItem';
import { RowClassArgs, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ExcelExportData, Workbook, WorkbookSheet, WorkbookSheetColumn, WorkbookSheetRowCell } from '@progress/kendo-angular-excel-export';
import { process, aggregateBy, filterBy } from '@progress/kendo-data-query';
import { OrderService } from '../../shared/services/order.service';
import * as _ from 'lodash';
//import { forEach } from '@angular/router';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { Item } from '../../shared/models/Item';
import { saveAs } from '@progress/kendo-file-saver';
import { ConstructionSearchParam } from '../../shared/models/ConstructionSearchParam';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    class?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}
@Component({
    selector: 'open-po-sub',
    templateUrl: './open-po-sub.component.html',
    styleUrls: ['./open-po-sub.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

 export class OpenPOSubComponent extends BaseGridUIComponent<ReportConstructionPOInfo, null, ConstructionService> implements OnInit, OnDestroy {

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    public pageSize = 50;
    svc_order: OrderService
    editingDetail: boolean = false;
    constructor(globals: GlobalsService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService, svc_order: OrderService) {
        super(globals);
        this.allData = this.allData.bind(this);
         this.svc_data = svc_data;
        this.svc_order = svc_order;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.aggregates = [
              { field: 'poTotal', aggregate: 'sum' }
            , { field: 'orderNumber', aggregate: 'count' }
            , { field: 'totalReceivedDollars', aggregate: 'sum' }
            , { field: 'sumAmtPaid', aggregate: 'sum' }
            , { field: 'notYetPaid', aggregate: 'sum' }
            , { field: 'unBilled', aggregate: 'sum' }
            , { field: 'blanketAmount', aggregate: 'sum' }
            , { field: 'invReceivedUnbilled', aggregate: 'sum' }
            , { field: 'nonPartInvReceivedUnbilled', aggregate: 'sum' }
            , { field: 'unbilledBillingCodes', aggregate: 'sum' }
            , { field: 'sumAmountBilled', aggregate: 'sum' }
        ];
        this.state.group = [{ field: 'poTotal', aggregates: this.aggregates }];
    }
    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    get referenceDataG(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    buyers: GItem[];
    buyerPersonId: any;
    buyerPersonIds: any;
    orderStatusIds: any;
    customerId: any;
    onCallRegionIds: any;
    divisionIds: any;
    accountClassIds: any;
    srvConstId: any
    techCreatedId: any = "0";
    poTypes: SItem[];
    poType: string;
    supplierId: any;
    techCreateds:GItem[] = [];
    exportFilteredData: any[];

    DispatchStatusCF: MSCLFilterClass;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;

    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceDataG !== undefined && this.referenceDataG !== null && this.referenceDataG.dispatchStatus !== undefined && this.referenceDataG.dispatchStatus !== null ? true : false;
        }
        catch{
            retVal = false;
        }
        return retVal;

    }

    closeDraw() {

    }

    override ngOnDestroy() {
        CommonFunctions.unsubscribe(this.subs_dataRef);
        super.ngOnDestroy();
    }

    ngOnInit() {
        this.getReferenceData();
    }
    getReferenceData() {
        this.dataLoading = true;
        this.svc_data.getConstPOInformationReference().subscribe((info: BaseMessageInfo) => {

            this.buyers = info.dcValues.Buyers;
            this.poTypes = info.dcValues.POTypes;
            this.dataLoading = false;
            this.techCreateds.push(new GItem({value:0,description:"",category:null,canSelect:true,reference:null }))
            this.techCreateds.push(new GItem({ value: 1, description: "Tech Created Only", category: null, canSelect: true, reference: null }))
            this.techCreateds.push(new GItem({ value: 2, description: "Hide Tech Created", category: null, canSelect: true, reference: null }))
        });
    }

    origData: any;
    getData() {
        this.dataLoading = true;
        let param: CommonParam = this.getParam();

        this.svc_data.GetConstPOSubInformation(param).subscribe((info: BaseMessageInfo) => {

            if (CommonFunctions.hasArrayElementValue(info.primaryReturn)) {

                for (let i = 0; i < info.primaryReturn.length; i++) {
                    info.primaryReturn[i] = this.setFlags(info.primaryReturn[i]);
                }
            }
            this.gridData = info.primaryReturn;
            this.originalGridData = info.primaryReturn;
            this.processGridData();
            this.dataLoading = false;
        });
    }
    getParam(initial: boolean = false) : CommonParam {
        let param: CommonParam = new CommonParam();
        if (!initial) {
            var isSub: boolean = null;
            switch (CommonFunctions.getStringValueIfNull(this.poType, "A")) {
                case "S":
                    isSub = true;
                    break;
                case "N":
                    isSub = false;
                    break;
            }
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.customerId = this.customerId;
            //param.addParam("BuyerPersonId", this.buyerPersonId);
            param.addParam("BuyerPersonIds", CommonFunctions.getCommaDelimitedStringFromArray(this.buyerPersonIds));
            param.addParam("SupplierId", this.supplierId);
            param.addParam("OrderStatusIds", CommonFunctions.getCommaDelimitedStringFromArray(this.orderStatusIds));
            param.addParam("AccountClassIds", CommonFunctions.getCommaDelimitedStringFromArray(this.accountClassIds));
            param.addParam("divisionIds", CommonFunctions.getCommaDelimitedStringFromArray(this.divisionIds));
            param.addParam("onCallRegionIds", CommonFunctions.getCommaDelimitedStringFromArray(this.onCallRegionIds));
            param.addParam("IsSub", true);
            param.addParam("srvConstId", this.srvConstId);
            param.addParam("techCreatedId", this.techCreatedId);

            //param.contractAdministratorId = this.contractAdministratorId;
            //param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            //param.jobTypeIds = this.relatedCategoryIds; //  CommonFunctions.getArrayFromCommaDelimitedString(this.relatedCategoryIds);
            //param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            //param.contractNo = this.constractNo;
        }
        return param;
    }
    apiFilter() {
        this.getData();
    }

    setFlags(order: ReportConstructionPOInfo) {

        if (order && order.orderBills) {

            var needsPayment = false;
            var hasApToCut = false;
            var hasApproved = false;

            if (CommonFunctions.hasArrayElementValue(order.orderBills)) {

                for (let i = 0; i < order.orderBills.length; i++) {
                    var bill = order.orderBills[i];
                    if (!CommonFunctions.hasArrayElementValue(bill.orderBillPayments)) {

                        var apToCutApprove = CommonFunctions.getBoolValueIfNull(bill.apToCutApprove, false);
                        var apToCut = CommonFunctions.getBoolValueIfNull(bill.apToCut, false);
                        var batchNumber = CommonFunctions.getBoolValueIfNull(bill.batchNumber, false);
                        if (!apToCutApprove && !apToCut && !batchNumber) {
                            needsPayment = true
                        }

                        if (!apToCutApprove && apToCut && !batchNumber) {
                            hasApToCut = true
                        }

                        if (apToCutApprove && apToCut && !batchNumber) {
                            hasApproved = true
                        }

                    }

                }

                order.needsPayment = needsPayment;
                order.hasApToCut = hasApToCut;
                order.hasApproved = hasApproved;

            }

        }

        return order;

    }

    clearFilters() {

        //this.buyerPersonId = null;
        this.buyerPersonIds = [];
        this.supplierId = null;
        this.orderStatusIds = [];
        this.customerId = null;
        this.accountClassIds = [];
        this.poType = null;
        this.onCallRegionIds = [];
        this.divisionIds = [];
        this.srvConstId = null;
        this.techCreatedId = null;
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.processGridData();
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.exportFilteredData = filterBy(this.gridData, this.filter);
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
        } else { this.aggregateResults = []; }
        this.DispatchStatusCF = new MSCLFilterClass('dispatchStatusName', 'dispatchStatusName', this.gridData);
    }

    rowClassFunction(context: RowClassArgs) {
        let data: ReportConstructionPOInfo = context.dataItem;

        if (data.dateEnteredDays >= 30 && data.blanketAmount <= 0) {
            return { over30: true }
        } else if (data.poTotal == 0 && data.blanketAmount <= 0) {
            if (data.dateEnteredDays >= 30) {
                return { over30: true }
            } else {
                return { zeroDollar: true }
            }
        }
        else if (data.blanketAmount > 0) {
            if (data.isSubContract) {
                if (data.sumAmtPaid === data.blanketAmount) {
                    return { blanketP: true, fullyPaid: true }
                } else { return { blanketP: true } }
            } else {
                if (data.sumAmountBilled === data.blanketAmount) {
                    return { blanketP: true, fullyPaid: true }
                } else { return { blanketP: true } }
            }
        }
    }
    tagMapper(tags: any[]): any[] {
        return tags.length < 2 ? tags : [tags];
    }
    details(data: ReportConstructionPOInfo) {

        let target: SearchTarget = SearchTarget.order;
        this.dqoiPopup(data.orderId, target, data.isConstruction);
    }
    //showDetailsPopup(dispatch) {
    //    this.activeChildComp = this.contentTypes.viewDispatch;
    //    this.windowData = { data: {}, viewDispatch: dispatch };
    //    this.showDetails = true;
    //}
    showDetailsPopup(data: ReportConstructionPOInfo, searchTarget: any = SearchTarget.dispatch) {

        //let target: SearchTarget = SearchTarget.dispatch;
        let id: any = data.dispatchId;
        if (searchTarget == SearchTarget.order) {
            id = data.orderId;
        }
        this.dqoiPopup(id, searchTarget, data.isConstruction);
    }
    onClosed() {
        this.showDetails = false;
    }
    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    detailsData: DispatchData;
    dqoiPopup(id: any, target: SearchTarget, isConstruction: boolean = false) {
        let data: DispatchData = new DispatchData();
        data.id = id;
        data.target = target;
        data.isConstruction = isConstruction;
        data.viewDispatch.dispatchId = id;

        this.detailsData = data;
        //this.cpPopWindow({ contentType: WindowContents.viewDispatch, boardData: data });
    }
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    onCPWindowClosed(e) {
        //        this.refreshData(DbTable.DispatchAssignments);
        this.cpShowWindow = false;
    }

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public exportGridToExcel(): void {
        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.origData) this.origData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    curData: any;
    orgData: any;
    rowsChanged: any[];
    updated: boolean = false;
    showDialog(dataItem: any) {
        this.editingDetail = true;
        this.curData = _.cloneDeep(dataItem);
        this.orgData = _.cloneDeep(dataItem);

    }
    onNoClick(event: Event): void {
        event.preventDefault();
    }

    onNoClickWithData(event: Event, dataItem: any): void {
        if (CommonFunctions.hasArrayValue(dataItem.orderBillPayments))
        event.preventDefault();
    }

    onNoClickWithDataApprove(event: Event, dataItem: any): void {
        if (CommonFunctions.hasArrayValue(dataItem.orderBillPayments) || !this.rights.ViewConstructionSubPOInformationApprove)
            event.preventDefault();
    }

    checkBoxChanged(e: any, dataItem, rowIndex:any, column, columnIndex) {
        this.updated = true;
        var ri = this.curData.orderBills.findIndex(a => a.orderBillId == dataItem.orderBillId)
        if (column.field == "apToCut") {
            if (this.curData.orderBills[ri].apToCut == true) { this.curData.orderBills[ri].apToCut = false; }
            else { this.curData.orderBills[ri].apToCut = true; }

        }
        if (column.field == "apToCutApprove") {
            if (this.curData.orderBills[ri].apToCutApprove == true) { this.curData.orderBills[ri].apToCutApprove = false; }
            else { this.curData.orderBills[ri].apToCutApprove = true; }

        }
    }
    notesChanged(value: string, dataItem: any) {
        var ri = this.curData.orderBills.findIndex(a => a.orderBillId == dataItem.orderBillId)
        if (ri >= 0) {
            this.updated = true;
            this.curData.orderBills[ri].notes = value;
            dataItem.notes = value;
        }
    }
    doUpdate() {
        var updated: any[] = [];
        for (let i = 0; i < this.curData.orderBills.length; i++) {
            var ri = this.orgData.orderBills.findIndex(a => a.orderBillId == this.curData.orderBills[i].orderBillId)
            if (this.curData.orderBills[i].apToCut != this.orgData.orderBills[ri].apToCut || this.curData.orderBills[i].apToCutApprove != this.orgData.orderBills[ri].apToCutApprove || CommonFunctions.getStringValueIfNull(this.curData.orderBills[i].notes, "") != CommonFunctions.getStringValueIfNull(this.orgData.orderBills[ri].notes, "")) {
                updated.push(this.curData.orderBills[i]);
            }
        }

        if (updated.length > 0) {
            this.svc_order.SaveOrderBillApprove(updated).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {

                    this.saveSuccess();
                    //this.closed.emit(false);
                }
                else {
                    this.saveError(info.message);
                }
            });
        } else { this.editingDetail = false;}

    }

    saveSuccess(message: string = null) {
        let not: string = "Bill Successfully Saved";
        var i = this.gridData.findIndex(a => a.orderId == this.curData.orderId);
        if (i >= 0) {
            this.gridData[i] = this.setFlags(_.cloneDeep(this.curData));
        }
        this.globals.notifySuccess(not);
        this.editingDetail = false;
        this.gridData = _.cloneDeep(this.gridData);
    }
    saveError(message: string = null) {
        let not: string = "There was a problem saving Bill "+ (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifyError(not, true);
    }

    closeDetail() {
        this.editingDetail = false;
    }
    public getExportData() {
        return this.origData ? this.origData.length : 0;
    }
    detailExpand(in1: any) {
        this.gridData[in1.index].showDetails = true;
    }
    detailCollapse(in1: any) {

        //var isValid = this.validateRow(in1.dataItem, in1.index);
        //if (isValid) {
            this.gridData[in1.index].showDetails = false;
        //}
        //else { in1.preventDefault(!isValid); }

        //return !isValid;
    }

    exporting: boolean = false;
    batchNumbers: Item[] = [];
    batchNumber: string = "New Batch";
    startExport() {
        this.exporting = true;
        this.getBatchNumbers();
        this.batchNumber = "New Batch";

    }
    closeExport() {

        this.exporting = false;
    }
    getBatchNumbers() {
        this.batchNumbers = [];
        for (let i = 0; i < this.gridData.length; i++) {
            for (let ii = 0; ii < this.gridData[i].orderBills.length; ii++) {

                if (this.gridData[i].orderBills[ii].batchId && this.gridData[i].orderBills[ii].apToCutApprove && this.gridData[i].orderBills[ii].apToCut) {

                    var batchId = this.gridData[i].orderBills[ii].batchId;

                    var index = this.batchNumbers.findIndex(a => a.description == batchId)

                    if (index < 0) {

                        var newItem = new Item()
                        newItem.description = batchId;
                        this.batchNumbers.push(newItem)
                    }

                }

            }

        }

            this.batchNumbers.sort((a, b) => (a.description < b.description) ? 1 : -1);
            var newItem = new Item()
            newItem.description = "New Batch";
        this.batchNumbers.push(newItem)
    }
    doExport() {
        var batchId = this.batchNumber;
        if (this.batchNumber == "New Batch") {
            var date = DateFunctions.getDateNow();
            batchId = "B" + date.getFullYear() + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
            var ids = [];

            for (let i = 0; i < this.gridData.length; i++) {
                for (let ii = 0; ii < this.gridData[i].orderBills.length; ii++) {

                    if (!this.gridData[i].orderBills[ii].batchId && this.gridData[i].orderBills[ii].apToCutApprove && this.gridData[i].orderBills[ii].apToCut) {

                        this.gridData[i].orderBills[ii].batchId = batchId;
                        ids.push(this.gridData[i].orderBills[ii].orderBillId);

                    }

                }

            }

            var batchIn = {

                ids: ids,
                batchId :batchId

            }
            this.svc_order.saveOrderBillBatchNo(batchIn).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {

                  //  this.saveSuccess();
                    //this.closed.emit(false);
                }
                else {
                    this.saveError(info.message);
                }
            });

        }

       var wsRows = []
      var  varHRow  =
        {
            cells: <WorkbookSheetRowCell[]>[
                // First cell
                { value: 'Supplier Name' },
                // Second cell
                { value: 'Invoice #' },
                { value: 'PO#' },
                { value: 'Payment Due Date' },
                { value: 'Bill Amount' },
                { value: 'AP to Cut' },
                { value: 'Approved' },
                { value: 'Approved By' },
                { value: 'Approval Date' },
                { value: 'Batch Date' },
                { value: 'Notes' },
            ]
        }
        wsRows.push(varHRow);

        for (let i = 0; i < this.gridData.length; i++) {
            for (let ii = 0; ii < this.gridData[i].orderBills.length; ii++) {

                if (this.gridData[i].orderBills[ii].batchId == batchId && this.gridData[i].orderBills[ii].apToCutApprove && this.gridData[i].orderBills[ii].apToCut) {

                    this.referenceDataG.getUser(this.gridData[i].orderBills[ii].apToCutApproveUserId)

                    var varHRow =
                    {
                        cells: <WorkbookSheetRowCell[]>[
                            // First cell
                            { value: this.gridData[i].supplierName },
                            // Second cell
                            { value: this.gridData[i].orderBills[ii].referenceNumber },
                            { value: this.gridData[i].orderNumber },
                            { value: this.gridData[i].orderBills[ii].netDueDate }, //Payment Due Date
                            { value: this.gridData[i].orderBills[ii].amountBilled },
                            { value: this.gridData[i].orderBills[ii].apToCut },
                            { value: this.gridData[i].orderBills[ii].apToCutApprove },
                            { value: this.referenceDataG.getUser(this.gridData[i].orderBills[ii].apToCutApproveUserId) },
                            { value: DateFunctions.formatDate_short(new Date(this.gridData[i].orderBills[ii].apToCutApproveDate)) },
                            { value: this.gridData[i].orderBills[ii].batchId },
                            { value: this.gridData[i].orderBills[ii].notes },
                        ]
                    }
                    wsRows.push(varHRow);

                }

            }

        }

        const workbook = new Workbook({
            sheets: <WorkbookSheet[]>[
                {
                    // Column settings (width)
                    columns: <WorkbookSheetColumn[]>[
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true },
                        { autoWidth: true }
                    ],
                    // Title of the sheet
                    name: 'SubContractorPOs',
                    // Rows of the sheet
                    rows: wsRows
                }
            ]
        });
        workbook.toDataURL().then(dataUrl => {
            saveAs(dataUrl, 'SubContractorPOs.xlsx');
        });

        this.exporting = false;
    }

    public showBillsDetails(dataItem: any): boolean {
        return CommonFunctions.hasArrayValue(dataItem.orderBillPayments)
    }

    ListDataDraw: any[] = [];
    paymentsToDate: number = 0.00;
    drawsWithRet: number = 0.00;
    totRet: number = 0.00;
    drawsLessRet: number = 0.00;
    public aggregateResultsDraws;
    gridDynamicDataPrime: any[] = [];
    rawDynData: BaseMessageInfo;
    NTEGridData: any[] = [];
    TaxGridData: any[] = [];
    dynamicLoading: boolean = true;
    ColumnHeadersDraws: ColumnSetting[];
    StaticColumnHeadersDraws: ColumnSetting[];
    DynamicColumnHeadersDraws: ColumnSetting[];
    public dynamicAggregates: any[] = [];
    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();
    public isLoadingDraw = false;
    getDataDraws(id) {
        this.isLoadingDraw = true;
        this.constSearchParam.contractId = id
        this.svc_data.GetJobDrawsByContractId(this.constSearchParam).subscribe((data: BaseMessageInfo) => {
            if (!data.warning) {
                this.ListDataDraw = data.primaryReturn;
                this.gridDataDraws = data.primaryReturn;

                this.processGridDataDraws();
                this.calcTotals();
            }

            if (data.warning) {
                //alert('data.warning');
            }
            this.isLoadingDraw = false;
        });
        this.dynamicLoading = true;
        this.gridDynamicDataPrime = [];

    }
    populateDynamicAggregates(data) {
        var iter = function (dynAggregates, record) {
            let fieldName = '';
            if (record.cat && record.cat != '') {
                fieldName = (record.cat ? record.cat : '');
                let index = dynAggregates.findIndex((element) => { return element.field === fieldName });
                if (index > -1) {
                    dynAggregates = dynAggregates;
                } else if (record.cat && record.cat != '') {
                    let newFieldName = (record.cat ? record.cat : '');
                    dynAggregates.push({
                        field: newFieldName,
                        aggregate: 'sum'
                    }
                    );
                }
            }
            return dynAggregates;
        };
        return data.reduce(iter, [])
    }
    pivotData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            let index = pivoted.findIndex((element) => { return element.invoiceId === record.invoiceId });
            if (index > -1 && record.cat && record.cat != '') {
                pivoted[index][(record.cat ? record.cat : '')] = record.amount;
            } else if (record.cat && record.cat != '') {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    [(record.cat ? record.cat : '')]: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            } else {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            }

            return pivoted;
        };

        return data.reduce(iter, [])
    }

    PopulateZeros(data) {
        data.forEach((row) => {
            this.dynamicAggregates.forEach((agg) => {
                if (!row[agg.field]) {
                    row[agg.field] = 0;
                }
            });
        });
        return data;
    }

    public getColumnHeaders(data) {

        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key }) == -1) {

                    let columnSettings: ColumnSetting = {
                        field: key,
                        title: key,
                        format: 'c2',
                        class: record.accountClassName,
                        type: 'text',
                        hidden: false
                    };

                    columns.push(columnSettings);
                }
            });

            return columns;
        };

        return data.reduce(iter, [])
    }

    public getStaticColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) != -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, [])
    }

    public getDynamicColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) == -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    class: record.field.substring(0, 3),
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, []).sort((a, b) => (a.field < b.field) ? -1 : (a.field > b.field) ? 1 : 0);
    }
     showDraws: boolean = false;
     closeDraws() {
         this.ListDataDraw = [];
         this.gridDataDraws = [];
         this.showDraws= false;

     }
     showDraw(id:any) {

         this.showDraws = true;
         //alert(JSON.stringify(id.masterJobId));
         this.getDataDraws(id.masterJobId);
     }
     ColumnHeaders: ColumnSetting[];
     StaticColumnHeaders: ColumnSetting[];
     DynamicColumnHeaders: ColumnSetting[];
    processDynamicDataForGrid(data: any) {
        let pivoted = this.pivotData(data);
        pivoted = this.PopulateZeros(pivoted);
        pivoted.sort((a, b) => {
            let aStr = a.invoiceNumber.split("-");
            let aPos = parseInt(aStr[1] ? aStr[1] : 0);
            let bStr = b.invoiceNumber.split("-");
            let bPos = parseInt(bStr[1] ? bStr[1] : 0);
            return ((aPos < bPos) ? -1 : ((aPos > bPos) ? 1 : 0));
        });

        this.ColumnHeaders = this.getColumnHeaders(pivoted);

        this.StaticColumnHeaders = this.getStaticColumnHeaders(this.ColumnHeaders);
        this.DynamicColumnHeaders = this.getDynamicColumnHeaders(this.ColumnHeaders);
        if (true) {//(this.gridDynamicDataPrime.length < 1) {//(this.DynamicColumnHeaders.length < 1) {
            let test = this.rawDynData.primaryReturn.filter(function (value, index, arr) { return value.billingTypeName.includes('NTE') && value.billingTypeName != 'NTE'; });

            let NTEColumns = this.compressNTEData(test)
                .sort((a, b) => (a.accountClassName < b.accountClassName) ? -1 : (a.accountClassName > b.accountClassName) ? 1 : 0);

            let testColumns = this.getColumnHeaders(NTEColumns);

            let extraDynamicColumnHeaders = this.generateDynamicColumnHeadersForEmptyData(testColumns);

            for (let i = 0; i < extraDynamicColumnHeaders.length; i++) {
                extraDynamicColumnHeaders[i].field = extraDynamicColumnHeaders[i].field.substring(0, extraDynamicColumnHeaders[i].field.length - 3);
                extraDynamicColumnHeaders[i].title = extraDynamicColumnHeaders[i].title.substring(0, extraDynamicColumnHeaders[i].title.length - 3);
            }

            //filter existing dynamic Headers out of the extras
            let filteredExtra = extraDynamicColumnHeaders;
            if (this.DynamicColumnHeaders.length > 0) {
                let existingHeaders = this.DynamicColumnHeaders.map(s => s.field);
                filteredExtra = extraDynamicColumnHeaders.filter(function (value, index, arr) { return existingHeaders.indexOf(value.field) == -1 });
            }

            filteredExtra.forEach((extra) => {
                this.DynamicColumnHeaders.push(extra);
            });

            //if (this.gridDynamicDataPrime.length < 1) {
            //    pivoted = [{ "invoiceNumber": "No Invoices" }];
            //    this.DynamicColumnHeaders.forEach((element, index) => { pivoted[0][element.field] = 0 });
            //}

        }

        return pivoted;
     }
     public generateDynamicColumnHeadersForEmptyData(data) {
         var iter = function (columns, record) {
             let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId', 'amount'];
             if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) == -1) {

                 let columnSettings: ColumnSetting = {
                     field: record.field,
                     title: record.field,
                     format: 'c2',
                     class: record.field.substring(0, 3),
                     type: 'text',
                     hidden: false
                 };
                 columns.push(columnSettings);
             }
             return columns;
         };

         return data.reduce(iter, []).sort((a, b) => (a.field < b.field) ? -1 : (a.field > b.field) ? 1 : 0);
     }

    compressNTEData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            let index = pivoted.findIndex((element) => { return element.accountClassId === record.accountClassId });
            if (index > -1 && record.cat && record.cat != '') {
                pivoted[index][(record.cat ? record.cat : '')] += record.amount;
                pivoted[index].amount = pivoted[index].amount + record.amount;
            } else if (record.cat && record.cat != '') {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    amount: record.amount,
                    [(record.cat ? record.cat : '')]: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            } else {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    amount: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            }

            return pivoted;
        };

        return data.reduce(iter, [])
    }

    gridDataDraws: any[] = [];
    calcTotals() {
        this.paymentsToDate = 0;
        this.drawsWithRet = 0;
        this.totRet = 0;
        this.drawsLessRet = 0;

        if (this.gridDataDraws) {
            this.gridDataDraws.forEach(i => {
                this.paymentsToDate += i.totalPayments;
                if (i.ret > 0) {
                    this.drawsWithRet += i.ret;
                    this.totRet += i.ret;
                    this.drawsLessRet += i.totalDraw;
                }
            });
            this.drawsLessRet = this.drawsLessRet - this.totRet;
        }
    }

    processGridDataDraws() {
        if (CommonFunctions.hasArrayElementValue(this.gridDataDraws)) {
            this.aggregateResults = aggregateBy(this.gridDataDraws, this.aggregates);

        }
    }
    public dynamicAggregateResults;
    processDynamicGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridDynamicDataPrime)) {
            this.dynamicAggregateResults = aggregateBy(this.gridDynamicDataPrime, this.dynamicAggregates);

        }
    }

}
